var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('leaderboard',{attrs:{"clientId":_vm.$store.getters.user.client_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }